import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, AppState } from '../../../types';
import { useEffect } from 'react';
import { HeatmapsRequestActions } from '../actions';
import { useFlags } from '@fullstory/react-hooks';

const emptyUnnamedHeatmap = {
  isLoading: false,
  isReady: true,
  hasError: false,
  unnamedHeatmap: undefined,
};

export const useFetchUnnamedHeatmap = (hash: string | undefined) => {
  const flags = useFlags();
  const dispatch = useDispatch<AppDispatch>();
  const { loading, error, lastRequested, data } = useSelector(
    (state: AppState) => state.heatmaps.unnamedHeatmap,
  );

  const unnamedHeatmap = hash ? data?.[hash] : undefined;

  useEffect(() => {
    if (hash && !unnamedHeatmap && !loading && !error) {
      dispatch(HeatmapsRequestActions.getUnnamedHeatmap({ hash })).catch(() =>
        console.error('Failed to get temporary heatmap state'),
      );
    }
  }, [dispatch, flags, hash, unnamedHeatmap, loading, error]);

  if (!hash) {
    return emptyUnnamedHeatmap;
  }

  return {
    isLoading: loading,
    // the unnamed heatmap could also be from UI flow and not be requested, so we are ready in that case
    isReady: (!loading && !error && lastRequested > -1) || !!unnamedHeatmap,
    hasError: error,
    unnamedHeatmap,
  };
};
